import { install as markLineExtension } from './markLine';

const echartsModule = ThsDataVStandardChart?.echarts;

// * component
const componentExtensions = [markLineExtension];

// * series
const chartExtensions = [];

const graphicExtensions = [];

if (echartsModule) {
  echartsModule.use(...componentExtensions, ...chartExtensions);
  graphicExtensions.forEach(extInstall => extInstall(echartsModule.graphic));
}
